<template>
  <div class="bgaproductsearch">
    <b-container>
      <div v-cloak>
        <b-alert
            :show="showAlert"
            variant="danger"
        >
          {{ error }}
        </b-alert>
        <template v-if="authorized">

          <bga-terms-of-use></bga-terms-of-use>

          <b-form ref="products" @submit.prevent="updateData">

            <div class="accordion" role="tablist">


              <cm-card card-title="Type of Product" toggle="accordion-ProdType" visible>

                <b-form-select v-model="unconfirmedValue" :options="productTypes" class="mt-3" @change="showConfirmation($event)" name="ProdType" size="sm"></b-form-select>

                <div v-if="showConfirmationDialog" class="confirmation-dialog">
                  <div class="pt-2 text-danger">Changing the Type of Product will reset all the search criteria (below) to their default values <b-link class="px-2 text-danger" @click="confirmSelection">Continue</b-link> <b-link class="px-2 text-danger" @click="cancelSelection">Cancel</b-link></div>
                </div>


              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One'" card-title="Carriers to include in search"
                       toggle="accordion-carriers">
                <b-form-checkbox
                    v-model="selectAllCarriers" :indeterminate="indeterminateCarriers" @change="select('selectedCarriers', selectAllCarriers, carriers, 'id', 'indeterminateCarriers')"
                >
                  {{ selectAllCarriers ? 'Unselect All' : 'Select All' }}
                </b-form-checkbox>
                <b-form-checkbox
                    v-for="carrier in carriers"
                    :key="carrier.id"
                    v-model="selectedCarriers"
                    :value="carrier.id"
                    @change="criteriaChanged = true"
                >
                  <span v-html="carrier.name"></span>
                </b-form-checkbox>

              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One' && selectedProductType !== 'Term'"
                       card-title="Single Life or Survivor" toggle="accordion-ProdNumberOfLives">

                <b-form-radio-group
                    name="ProdNumberOfLives"
                    v-model="selectedProdNumberOfLives"
                    @change="criteriaChanged = true"
                >
                  <b-form-radio value="Single Life">Single Life</b-form-radio>
                  <b-form-radio value="Survivor">Survivor</b-form-radio>
                </b-form-radio-group>

              </cm-card>


              <cm-card v-if="selectedProductType === 'Term'" card-title="Term Duration(s)"
                       toggle="accordion-ProdDuration">

                <b-form-checkbox
                    v-model="selectAllProdDurations" :indeterminate="indeterminateProdDurations"  @change="select('selectedProdDurations', selectAllProdDurations, ProdDurationSearchList, 'value', 'indeterminateProdDurations')"
                >
                  {{ selectAllProdDurations ? 'Unselect All' : 'Select All' }}
                </b-form-checkbox>
                <b-form-checkbox
                    v-for="ProdDuration in ProdDurationSearchList"
                    :key="ProdDuration.text"
                    v-model="selectedProdDurations"
                    :value="ProdDuration.value"
                    @change="criteriaChanged = true"
                >
                  {{ ProdDuration.text }}
                </b-form-checkbox>

              </cm-card>


              <cm-card v-if="selectedProductType === 'Term'" card-title="Convertible Term Options"
                       toggle="accordion-ProdConvertible">

                <b-form-radio-group
                    name="ProdConvertible"
                    stacked
                    v-model="selectedProdConvertible"
                    @change="criteriaChanged = true"
                >
                  <b-form-radio value="">No Preference</b-form-radio>
                  <b-form-radio value="Product not Convertible">Product not Convertible</b-form-radio>
                  <b-form-radio value="Product Convertible to Single Life">Product Convertible to Single Life
                  </b-form-radio>
                  <b-form-radio value="Product Convertible to Single Life or Survivor">Product Convertible to Single
                    Life or Survivor
                  </b-form-radio>
                </b-form-radio-group>

              </cm-card>

              <cm-card
                  v-if="selectedProductType === 'Indexed Universal Life' || selectedProductType === 'Variable Universal Life'"
                  card-title="Product Objective" toggle="accordion-ProdObjective"  >

<!--                <b-form-radio-group name="ProdObjective" stacked v-model="selectedProdObjective">-->
<!--                  <b-form-radio value="">No Preference</b-form-radio>-->
<!--                  <b-form-radio value="Accumulation">Accumulation</b-form-radio>-->
<!--                  <b-form-radio value="Protection">Protection</b-form-radio>-->
<!--                  <b-form-radio value="Blended">Blended</b-form-radio>-->
<!--                </b-form-radio-group>-->

                <b-form-checkbox-group
                    name="ProdObjective"
                    v-model="selectedProdObjective"
                    @change="criteriaChanged = true"
                >
                  <b-form-checkbox value="Accumulation">Accumulation</b-form-checkbox>
                  <b-form-checkbox value="Protection">Protection</b-form-checkbox>
                  <b-form-checkbox value="Blended">Blended</b-form-checkbox>
                </b-form-checkbox-group>


              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One'" card-title="Required ABRs"
                       toggle="accordion-ABRLinks">
              <b-form-checkbox-group
                  name="abrs"
                  v-model="selectedABRLinks"
                  @change="criteriaChanged = true"
              >
                <b-form-checkbox
                    v-for="ABRLink in ABRLinks"
                    :key="ABRLink.value"
                    :value="ABRLink.value"
                >
                  {{ ABRLink.text }}
                </b-form-checkbox>
              </b-form-checkbox-group>
              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One'" card-title="Required Riders/Options" toggle="accordion-ProdRidersOptions">

                <b-form-checkbox
                    v-for="ProdRidersOption in ProdRidersOptions"
                    :key="ProdRidersOption"
                    v-model="selectedProdRidersOptions"
                    :value="ProdRidersOption"
                    @change="criteriaChanged = true"
                >
                  {{ ProdRidersOption }}
                </b-form-checkbox>

              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One'" card-title="Min/Max Issue Age"
                       toggle="accordion-ProdIssueAge">

                <b-form-radio-group
                    v-model="selectedProdIssueAgeType"
                    name="ProdIssueAgeType"
                    @change="criteriaChanged = true"
                >
                  <b-form-radio value="">No Preference</b-form-radio>
                  <b-form-radio value="By Birthdate">By Birthdate</b-form-radio>
                  <b-form-radio value="By Age">By Age</b-form-radio>
                </b-form-radio-group>

                <b-form-group
                    v-if="selectedProductType !== 'Select One' && selectedProdIssueAgeType === 'By Birthdate'"
                    label="Issue Age"
                >
                  <b-form-input
                      v-mask="'##/##/####'"
                      autocomplete="off"
                      name="ProdIssueBirthdate"
                      placeholder="mm/dd/yyyy"
                      type="text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                    v-if="selectedProductType !== 'Select One' && selectedProdIssueAgeType === 'By Age'"
                    label="Age"
                >
                  <b-form-input max="99" min="0" name="ProdIssueAge" type="number"  ></b-form-input>
                </b-form-group>

              </cm-card>


              <cm-card v-if="selectedProductType !== 'Select One'"
                       card-title="Face Amount (for Minimum Face Amount check)" toggle="accordion-ProdDBMin">

                <b-form-input v-money="money" v-model="ProdDBMinAmount" name="ProdDBMin" type="text" @change="(ProdDBMinAmount != 0 ? criteriaChanged = true : '')"></b-form-input>

              </cm-card>

              <cm-card
                  v-if="selectedProductType !== 'Select One' && selectedProductType !== 'Term' && selectedProductType !== 'Whole Life'"
                  card-title="Required death benefit options" toggle="accordion-ProdDBOptions">

                <b-form-checkbox
                    v-for="ProdDBOptions in ProdDBOptionsList"
                    :key="ProdDBOptions"
                    :value="ProdDBOptions"
                    v-model="selectedProdDBOptions"
                    @change="criteriaChanged = true"
                >
                  {{ ProdDBOptions }}
                </b-form-checkbox>

              </cm-card>

              <cm-card
                v-if="selectedProductType !== 'Select One'"
                card-title="Product MUST be Available in the following State"
                toggle="accordion-ProdRequiredState"
              >
                <b-form-select v-model="ProdRequiredState" :options="stateListSelectOptions" class="mt-3" name="ProdRequiredState" size="sm"></b-form-select>
              </cm-card>

              <b-form-checkbox
                  v-if="selectedProductType === 'Indexed Universal Life' || selectedProductType === 'Variable Universal Life'"
                  class="my-2"
                  name="ProdDBLifetimeGuar"
                  v-model="ProdDBLifetimeGuar"
                  value="1"
                  unchecked-value="0"
                  switch
                  @change="criteriaChanged = true"
              >
                Must offer a lifetime guaranteed death benefit
              </b-form-checkbox>

              <b-form-checkbox
                  v-if="selectedProductType === 'Indexed Universal Life'"
                  class="my-2"
                  name="ProdPersistBonus"
                  v-model="ProdPersistBonus"
                  value="1"
                  unchecked-value="0"
                  switch
                  
              >
                Must offer a persistency bonus
              </b-form-checkbox>

              <b-form-checkbox
                  v-if="selectedProductType === 'Guaranteed Universal Life' || selectedProductType === 'Current Assumption Universal Life' || selectedProductType === 'Indexed Universal Life' || selectedProductType === 'Variable Universal Life'"
                  class="my-2"
                  name="ProdSurrROP"
                  v-model="ProdSurrROP"
                  value="1"
                  unchecked-value="0"
                  switch
                  @change="criteriaChanged = true"
              >
                Must offer a Return of Premium on Surrender option
              </b-form-checkbox>

              <b-form-checkbox
                  v-if="selectedProductType === 'Guaranteed Universal Life' || selectedProductType === 'Current Assumption Universal Life' || selectedProductType === 'Indexed Universal Life' || selectedProductType === 'Variable Universal Life'"
                  class="my-2"
                  name="ProdRollingTargets"
                  v-model="ProdRollingTargets"
                  value="1"
                  unchecked-value="0"
                  switch
                  @change="criteriaChanged = true"
              >
                Must offer Rolling Targets
              </b-form-checkbox>

              <b-form-checkbox
                  v-if="selectedProductType !== 'Select One'"
                  class="my-2"
                  name="ProdDateVerified"
                  switch
                  v-model="selectedProdDateVerified"
                  @change="criteriaChanged = true"
              >
                Only show products verified in the last 18 months
              </b-form-checkbox>

              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <b-button variant="success" v-on:click="updateData">{{this.buttonText}}</b-button>
                  <b-button class="ml-2" variant="light" @click="clearSearch(true)" v-if="items.length > 0"  >Clear</b-button>
                </div>
                <img style="width:120px" src="https://carriermatrix.com/wp-content/uploads/Engineered-By-Simplicity.jpg"  alt="Engineered By Simplicity Group">
              </div>


            </div>
          </b-form>

        </template>
      </div>


    </b-container>
  </div>

</template>

<script>
import {bus} from "@/event-bus";
import HelperFunctions from "@/mixins/helper-functions"
export default {
  name: "BGAProductSearch",
  mixins: [HelperFunctions],
  props: {},
  data() {
    // const currency = new Intl.NumberFormat("en-US", {
    //   style: "currency",
    //   currency: "USD",
    //   minimumFractionDigits: 2,
    // })
    return {
      criteriaChanged: false,
      ProdDBMinAmount: 0,
      showConfirmationDialog: false,
      unconfirmedValue: 'Select One',
      selectedProductType: 'Select One',
      selectedProdNumberOfLives: 'Single Life',
      selectedProdConvertible: '',
      selectedProdObjective: ['Accumulation', 'Protection', 'Blended'],
      selectedProdDurations: ['1,2,3,4,5,6,7,8,9', '10,11,12,13,14,15,16,17,18,19', '20,21,22,23,24,25,26,27,28,29', '30,31,32,33,34,35,36,37,38,39', '40,41,42,43,44,45,46,47,48,49,50'],
      selectAllProdDurations: true,
      selectedABRLinks: [],
      indeterminateProdDurations: true,
      selectedProdIssueAgeType: '',
      selectedProdRidersOptions: [],
      selectedProdDBOptions: [],
      ProdDBLifetimeGuar: false,
      ProdPersistBonus: false,
      ProdRollingTargets: false,
      ProdSurrROP: false,
      ProdRequiredState: '',
      selectedProdDateVerified: true,
      productTypes: [],
      ProdDurationSearchList: [
        {text: '1 to 9 years', value: '1,2,3,4,5,6,7,8,9'},
        {text: '10 to 19 years', value: '10,11,12,13,14,15,16,17,18,19'},
        {text: '20 to 29 years', value: '20,21,22,23,24,25,26,27,28,29'},
        {text: '30 to 39 years', value: '30,31,32,33,34,35,36,37,38,39'},
        {text: '40+ years', value: '40,41,42,43,44,45,46,47,48,49,50'},
      ],
      ABRLinks: [
        {text: 'Terminal Illness', value: 'Terminal illness'},
        {text: 'Critical Illness/Injury or Specified Conditions', value: 'Critical illness/injury'},
        {text: 'Chronic Illness', value: 'Chronic illness'},
        {text: 'Long-Term Care', value: 'Long-Term care'},
        {text: 'Other', value: 'Other'},
      ],
      ProdRidersOptions: [
        'Waiver of Premium/Charges',
        'Payor Benefit',
        'Additional Term (on Insured)',
        'Spouse Term',
        'Child Term',
        'Other Insured Term',
        'Beneficiary Income',
        'First-to-Die',
        'Accidental Death Benefit',
        'Automatic Premium Loan',
        'Return of Premium',
        'Cost of Living Increase',
        'Disability Income',
        'Early/Enhanced Cash Value',
        'Overloan Protection',
        'Convert Cash Value to Guaranteed Income',
        'Guaranteed Insurability',
        'Transfer of Insured',
      ],
      ProdDBOptionsList: [
        'Level Specified Amount',
        'Specified Amount plus Policy Value',
        'Specified Amount plus Return of Premiums',
      ],
      stateList: {
        '': 'None Selected',
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District of Columbia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming',
      },
      items: [],
      fields: [
        {key: 'carrier', label: 'Carrier', formatter: value => {
            return (value ? this.getCarrierNameByID(value) : '')
          },  sortByFormatted: 'getCarrierNameByID', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'name', label: 'Product', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdNumberOfLives', label: 'Single Life or Survivor', tdClass: 'column-width', thClass: 'column-width'},
        {
          key: 'ProdDuration', label: 'Durations Offered',  formatter: value => {
            return (value ? value.join(', ') : '')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdConvertible', label: 'Convertible', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdConversionDetails',
          label: 'Conversion Details',
          formatter: (value, key, item) => {return (item.ProdConvertible !== 'Product not Convertible' ? this.toText(value) : 'N/A')
          },
          callback: item => {return (item.ProdConvertible !== 'Product not Convertible' ? this.toText(item.ProdConversionDetails) : 'N/A')
          },
          tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdObjective', label: 'Objective', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRLinks', label: 'ABRs',  callback: item => {
            return (item ? this.listABRsForExcel(item.ABRLinks) : '')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdRidersOptions', label: 'Riders',  formatter: value =>          {
            if (value)
              return value.join(', ')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdIssueAgeType', label: 'Issue Age', tdClass: 'column-width', thClass: 'column-width', formatter: (value, key, item) => {
              return (item ? item.ProdIssueAgeMin + ' - ' + item.ProdIssueAgeMax + ', ' + item.ProdIssueAgeType : '')
          }, callback: item => {
            return (item ? item.ProdIssueAgeMin + ' - ' + item.ProdIssueAgeMax + ', ' + item.ProdIssueAgeType : '')
          }
        },
        {key: 'ProdIssueAgeInfo', label: 'Issue Age Details',  formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdUWClasses', label: 'Underwriting Classes',  formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdDBMin', label: 'Minimum Face',  formatter: value => {
            return (value ? '$' + value : '')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdDBOptions', label: 'Death Benefit Options', tdClass: 'column-width', thClass: 'column-width'},
        {
          key: 'ProdDBLifetimeGuar', label: 'Lifetime Guaranteed DB?',  formatter: value => {
            return (value ? 'Yes' : 'No')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {
          key: 'ProdDBGuarDescrip',
          label: 'Guaranteed DB Features/Options',
          formatter: value => {
            return (value ? this.toText(value) : 'N/A')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {
          key: 'ProdMaxAnnualPrem', label: 'Max Annual Premium',  formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'
        },
        {
          key: 'ProdPersistBonus', label: 'Persistency Bonus?',  formatter: value => {
            return (value ? 'Yes' : 'No')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {
          key: 'ProdPersistBonusInfo', label: 'Persistency Bonus Details',  formatter: (value, key, item) => {
            if (!item.ProdPersistBonus)
              return 'N/A'
            else
              return (value && item.ProdPersistBonus ? this.toText(value) : 'N/A')
          }, callback:item => {
            if (!item.ProdPersistBonus)
              return 'N/A'
            else
              return (item.ProdPersistBonusInfo ? this.toText(item.ProdPersistBonusInfo) : '')

          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdSurrCharges', label: 'Surrender Charges',  formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {
          key: 'ProdSurrROP', label: 'ROP on Surrender Feature/Option?',  formatter: value => {
            return (value ? 'Yes' : 'No')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdRollingTargets', label: 'Rolling Targets?',  formatter: value => {
            return (value ? 'Yes' : 'No')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'ProdRollingTargetsInfo', label: 'Rolling Targets Details',

          formatter: (value, key, item) => {
            if (item.ProdRollingTargets === 'No')
              return 'N/A'
            else
              return (value ? this.toText(value) : 'N/A')
          }, callback:item => {
            if (!item.ProdRollingTargets)
              return 'N/A'
            else
              return (item.ProdRollingTargetsInfo ? this.toText(item.ProdRollingTargetsInfo) : '')
          },
          tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdCapParRates', label: 'Current Cap/Par Rates', formatter:  value => {
            return this.listLinks(value, 'ProdURL')
          }, tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdStateUnavailability', label: 'Product NOT Available in These States', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdStateAvailabilityDetails', label: 'Product State Availability details, if any', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdAddlInfo', label: 'Additional Information', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdInfoLinks', label: 'Links To Additional Information',  formatter:  value => {
            return this.listLinks(value, 'ProdURL')
          }, tdClass: 'column-width', thClass: 'column-width'
        },
        {key: 'verification_date', label: 'Date Verified',  formatter: value => {
            if (value) {
              let date = new Date(value)
              return date.toLocaleDateString("en-US")
            } else {
              return ''
            }
          }, tdClass: 'width-126', thClass: 'width-126'},
      ],


    }
  },
  mounted() {

    this.fetchCarriers().catch(error => {
      console.error(error)
    })

    this.fetchAgencyProductTypes().catch(error => {
      console.error(error)
    })

  },

  methods: {

    async fetchAgencyProductTypes() {
      const ms = Date.now()
      const params = '?agency_id=' + this.agencyId + '&api_key=' + this.apiKey + '&cache_buster=' + ms + '&site=' + window.location.href
      this.productTypes = await fetch(this.$hostname + '/cm_api/cm/v1/prod_types' + params)
          .then(res => {
            return res.json()
          })
          .then(productTypes => productTypes)
      this.productTypes.unshift('Select One')
    },


    updateResults() {
      bus.$emit("update-product-results-items", this.items)
      bus.$emit("update-product-visible-fields", this.visibleFields)
    },

    async updateData() {

      this.items = []
      this.updateResults()
      this.showAlert = false

      if (!this.selectedCarriers.length) {
        this.showAlert = true
        this.error = 'At least one Carrier needs to be selected'
        this.scrollToTop()
        return
      }
      const formData = new FormData(this.$refs['products'])
      formData.append('selected_carriers', this.selectedCarriers)
      formData.append('ABRLinks', this.selectedABRLinks)
      formData.delete('abrs')
      formData.delete('ProdObjective')
      if (this.selectedProdObjective && this.selectedProductType === 'Indexed Universal Life' || this.selectedProductType === 'Variable Universal Life') {
        formData.append('selected_ProdObjective', this.selectedProdObjective)
      }
      if (this.selectedProdDurations && this.selectedProductType === 'Term') {
        formData.append('selected_ProductDuration', this.selectedProdDurations)
      }
      if (this.selectedProdRidersOptions) {
        formData.append('selected_ProdRidersOptions', this.selectedProdRidersOptions)
      }
      if (this.selectedProdDBOptions) {
        formData.append('selected_ProdDBOptions', this.selectedProdDBOptions)
      }
      formData.append('agency_id', this.agencyId)
      formData.append('api_key', this.apiKey)
      formData.append('site', window.location.href)
      const data = {}
      for (let [key, val] of formData.entries()) {
        Object.assign(data, {[key]: val})
      }
      const params = new URLSearchParams(data)
      const options = {
        headers: new Headers(),
      }
      this.items = await fetch(this.$hostname + '/cm_api/cm/v1/product-api?' + params, options)
          .then(res => {
            return res.json()
          })
          .then(items => {            
            return items;
          })

      if (this.items.error) {
        this.showAlert = true
        this.error = this.items.error.message
        this.query_args = this.items.error.query_args
        this.scrollToTop()
      }

      if (this.selectedABRLinks.length && this.items.length > 0) {
        let filteredItemsByABRType = []
        let checker = (arr, target) => target.every(v => arr.includes(v))
        this.items.forEach((item) => {
          let abrTypes = []
          if (item.ABRLinks.length > 0) {
            item.ABRLinks.forEach((link) => {
              abrTypes.push(link.abr_type)
              if (checker(abrTypes, this.selectedABRLinks)) {
                filteredItemsByABRType.push(item)
              }
            })
          }
        })

        if (filteredItemsByABRType.length === 0) {
          this.showAlert = true
          this.error = 'No Products Found'
          this.scrollToTop()
        }

        this.items = [...new Set(filteredItemsByABRType)]
      }

      // Apply column widths from the API response
      if (this.items.length > 0 && this.items[0]._column_widths) {
        // Apply the dynamic column widths to each field
        this.visibleFields.forEach(field => {
          // Find the first item that has width information for this field
          const firstItem = this.items.find(item => item._column_widths && item._column_widths[field.key]);
          
          if (firstItem && firstItem._column_widths[field.key]) {
            const width = firstItem._column_widths[field.key];
            field.tdClass = `width-${width}`;
            field.thClass = `width-${width}`;
            field.thStyle = { width: `${width}px`, minWidth: `${width}px` };
            field.tdStyle = { width: `${width}px`, minWidth: `${width}px` };
          }
        });
      }

      this.updateResults()

    },


    listABRsForExcel(value) {
      if (!value && typeof value != 'object')
        return
      if (value.length) {
        return value.map(function (e) {
          return e.title
        }).join(', ')
      } else {
        return ''
      }

    },



    cancelSelection () {
      this.unconfirmedValue = this.selectedProductType
      this.showConfirmationDialog = false
    },

    confirmSelection () {
      this.showConfirmationDialog = false
      this.selectedProductType = this.unconfirmedValue
      this.onTypeChange(this.selectedProductType)
    },

    showConfirmation (value) {
      if (this.selectedProductType !== 'Select One' && this.criteriaChanged === true) {
        this.showConfirmationDialog = true
        this.unconfirmedValue = value
      } else {
        this.selectedProductType = value
        this.onTypeChange(value)
      }
    },



    clearSearch(clearType = false) {

      this.items = []
      bus.$emit("update-product-results-items", this.items)

      if (clearType) {
        this.selectedProductType = 'Select One'
        this.unconfirmedValue = 'Select One'
      }

      this.selectedCarriers = []
      for (let key in this.carriers) {
        this.selectedCarriers.push(this.carriers[key].id)
      }
      this.selectAllCarriers = true
      this.indeterminateCarriers = true
      this.selectedProdNumberOfLives = 'Single Life'
      this.selectedProdConvertible = ''
      this.selectedProdObjective = ['Accumulation', 'Protection', 'Blended']
      this.selectedProdDurations  ['1,2,3,4,5,6,7,8,9', '10,11,12,13,14,15,16,17,18,19', '20,21,22,23,24,25,26,27,28,29', '30,31,32,33,34,35,36,37,38,39', '40,41,42,43,44,45,46,47,48,49,50']
      this.selectAllProdDurations = true
      this.selectedABRLinks = []
      this.indeterminateProdDurations = true
      this.selectedProdIssueAgeType = ''
      this.selectedProdRidersOptions = []
      this.selectedProdDBOptions = []
      this.selectedProdDateVerified = true
      this.ProdDBMin = ''
      this.ProdDBLifetimeGuar = false
      this.ProdPersistBonus = false
      this.ProdSurrROP = false
      this.ProdRollingTargets = false
      this.ProdRequiredState = ''

    },


    onTypeChange(e) {

      this.clearSearch()

      switch (e) {
        case 'Term':
          this.buildVisibleFields(['carrier', 'name', 'ProdDuration', 'ProdConvertible', 'ProdConversionDetails', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks', 'verification_date'])
          break
        case 'Guaranteed Universal Life':
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdDBOptions', 'ProdMaxAnnualPrem', 'ProdSurrCharges', 'ProdSurrROP', 'ProdRollingTargets', 'ProdRollingTargetsInfo', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks', 'verification_date'])
          break
        case 'Current Assumption Universal Life':
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdDBOptions', 'ProdMaxAnnualPrem', 'ProdSurrCharges', 'ProdSurrROP', 'ProdRollingTargets', 'ProdRollingTargetsInfo', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks', 'verification_date'])
          break
        case 'Indexed Universal Life':
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ProdObjective', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdDBOptions', 'ProdDBLifetimeGuar', 'ProdDBGuarDescrip', 'ProdMaxAnnualPrem', 'ProdPersistBonus', 'ProdPersistBonusInfo', 'ProdSurrCharges', 'ProdSurrROP', 'ProdRollingTargets', 'ProdRollingTargetsInfo', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdCapParRates',  'ProdInfoLinks', 'verification_date'])
          break
        case 'Variable Universal Life':
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ProdObjective', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdDBOptions', 'ProdDBLifetimeGuar', 'ProdDBGuarDescrip', 'ProdMaxAnnualPrem', 'ProdSurrCharges', 'ProdSurrROP', 'ProdRollingTargets', 'ProdRollingTargetsInfo', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks',  'verification_date'])
          break
        case 'Whole Life':
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks',  'verification_date'])
          break
        default:
          this.buildVisibleFields(['carrier', 'name', 'ProdNumberOfLives', 'ABRLinks', 'ProdRidersOptions', 'ProdIssueAgeType', 'ProdIssueAgeInfo', 'ProdUWClasses', 'ProdDBMin', 'ProdRollingTargets', 'ProdRollingTargetsInfo', 'ProdStateUnavailability', 'ProdStateAvailabilityDetails', 'ProdAddlInfo', 'ProdInfoLinks', 'verification_date'])
      }

      bus.$emit("update-product-visible-fields", this.visibleFields)

    },
  },
  computed: {
    stateListSelectOptions: function() {
      return Object.entries(this.stateList).map(([abbreviation, fullName]) => ({ value: abbreviation, text: fullName }));
    },
   },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
